import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ScrollReveal from "scrollreveal";
import line from "../../assets/line.webp";
import styles from "./EYouthProject.module.css";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function SliderComponent() {
  const { t, i18n } = useTranslation();
  const imageRef = useRef(null);
  const [index, setIndex] = useState(0);
  const [imageUrl, setImageUrl] = useState([{}]);
  const totalSlides = 36;
  const autoplayInterval = 3000; // Change this to adjust the autoplay interval
  const screenWidth = window.innerWidth;

  //calling the API of the Projects Images
  const fetchImage = async () => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Basic N2MwNWZiZGFlZTQwYjQ2OmViZmU0YjkxMDVjYTY5MQ=="
    );
    myHeaders.append(
      "Cookie",
      "full_name=Guest; sid=Guest; system_user=no; user_id=Guest; user_image="
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        "https://erpeyouth.eyouthlearning.com/api/resource/Home Projects?fields=[%22arabic_photo%22%2C%22english_photo%22]&limit=1000",
        requestOptions
      );

      if (!response.ok) {
        throw new Error(
          `Failed to fetch: ${response.status} ${response.statusText}`
        );
      }

      const result = await response.json();
      // console.log("result", result.data);

      // Update the state with the image URL
      setImageUrl(result?.data);
      // console.log("first", result?.data);
    } catch (error) {
      console.error("Error fetching image:", error.message);
    }
  };

  useEffect(() => {
    fetchImage();
  }, []);

  useEffect(() => {
    const sr = ScrollReveal();
    sr.reveal(imageRef.current, {
      duration: 500,
      distance: screenWidth < 768 ? "0px" : "100px",
      easing: "ease-in",
      origin: "left",
      reset: false,
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const autoplay = setInterval(() => {
      setIndex((prevIndex) =>
        prevIndex === totalSlides - 1 ? 0 : prevIndex + 1
      );
    }, autoplayInterval);

    return () => clearInterval(autoplay);
  }, []);

  const nextSlide = () => {
    setIndex((prevIndex) =>
      prevIndex === totalSlides - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setIndex((prevIndex) =>
      prevIndex === 0 ? totalSlides - 1 : prevIndex - 1
    );
  };

  return (
    <>
      <div className={styles.container}>
        <div className="d-flex flex-column justify-around-center align-items-center mt-5">
          <h2 className={styles.trainerTitle}>{t("Our_projects")}</h2>
          <LazyLoadImage src={line}
            alt="underline"
            className={screenWidth < 768 ? "w-50 bg-red" : ""}
            ref={imageRef} />
        </div>

        <div
          className={
            screenWidth < 768
              ? i18n.language === "ar" ?
                styles.mainMobile : styles.mainMobileEN
              : i18n.language === "ar"
                ? `${styles.main}`
                : `${styles.mainEN}`
          }
        >
          {!screenWidth < 768 && (
            <ArrowForwardIosIcon
              onClick={nextSlide}
              className={i18n.language === "ar" ? styles.next : styles.nextEN}
              style={{ fontSize: "23px" }}
            />
          )}

          <div>
            {imageUrl.map((image, i) => {
              return (
                <div
                  key={i}
                  className={`${styles.card} ${index === i
                    ? styles.front
                    : index === (i + 1) % totalSlides
                      ? styles.left
                      : index === (i - 1 + totalSlides) % totalSlides
                        ? styles.right
                        : ""
                    }`}
                >
                  <LazyLoadImage
                    alt="icon"
                    width="100%"
                    src={
                      i18n.language === "ar"
                        ? `https://erpeyouth.eyouthlearning.com${image?.arabic_photo}`
                        : `https://erpeyouth.eyouthlearning.com${image?.english_photo}`
                    }
                  />
                </div>
              );
            })}
          </div>

          {!screenWidth < 768 && (
            <ArrowBackIosIcon
              onClick={prevSlide}
              className={
                i18n.language === "ar"
                  ? styles.prev_slider
                  : styles.prev_sliderEN
              }
            />
          )}
        </div>
      </div>
      {screenWidth < 768 && (
        <div className={styles.arrows}>
          <ArrowForwardIosIcon
            onClick={nextSlide}
            className={styles.nextMobile}
            style={{ fontSize: "23px" }}
          />
          <ArrowBackIosIcon
            onClick={prevSlide}
            className={styles.prev_sliderMobile}
          />
        </div>
      )}

      <div className="d-flex justify-content-center mb-3">
        <Link to="/our-projects">
          <button
            aria-label="button to be clicked"
            aria-labelledby="button to be clicked"
            className={
              screenWidth < 768
                ? `btn btn-primary ${styles.btn_see_all}`
                : `btn btn-primary ${styles.btn_see_all}`
            }
          >
            {t("View All")}
          </button>
        </Link>
      </div>
    </>
  );
}
